import { linkParts } from '@smbsuite/i18n';
import { Link } from 'react-router';
import { useI18n } from '../../i18n';

const DOCUMENTS: Record<string, string> = { terms: '/legal/terms', dpa: '/legal/dpa', privacy: '/privacy' };

/**
 * What a terms checkbox says (TF-388): one translated sentence with the documents' links inside it,
 * for example "I accept, for the company, the Terms of service, the Data processing agreement and the
 * Privacy policy." One span, so it wraps as text and a comma stays beside its link. The links open in
 * a new tab, which keeps what the form holds; a click on one does not tick the box.
 */
export function LegalConsent({ forCompany }: { forCompany: boolean }) {
  const { t } = useI18n();
  return (
    <span className="legal-consent">
      {linkParts(t(forCompany ? 'terms.consentForCompany' : 'terms.consentForMe')).map((part, index) =>
        typeof part === 'string' ? (
          part
        ) : (
          <Link key={index} to={DOCUMENTS[part.link] ?? '/legal/terms'} target="_blank" rel="noopener">
            {part.text}
          </Link>
        ),
      )}
    </span>
  );
}
